<template>
  <div id="change-password-box-container">
    <div v-if="regRulesAndTermsLoader" class="group-data-loader">
      <spinner/>
    </div>
    <div v-else>
      <div class="data-row">
        <input
          type="password"
          :disabled="loader"
          v-model="formData.oldPassword"
          placeholder="Текущий пароль"
          id="oldPasswordInput">
        <span v-if="formData.oldPassword && formData.oldPassword.length > 0"
          @click="showHidePassword"
          title="Показать/скрыть пароль"
          id="toggle-old-password"
          toggle="#oldPasswordInput"
          class="password-icon">👁</span>
      </div>
      <div class="data-row">
        <input
          type="password"
          :disabled="loader"
          :min-legnth="regRulesAndTerms.passwordMinLength"
          :max-length="regRulesAndTerms.passwordMaxLength"
          v-model="formData.newPassword"
          @input="checkPasswordStrength"
          placeholder="Новый пароль"
          id="newPasswordInput">
        <span v-if="formData.newPassword && formData.newPassword.length > 0"
          @click="showHidePassword"
          title="Показать/скрыть пароль"
          id="toggle-new-password"
          toggle="#newPasswordInput"
          class="password-icon">👁</span>
      </div>
      <!-- Визуальный индикатор сложности -->
      <div class="strength-meter" v-if="formData.newPassword">
        <div class="bar" :class="currentLevel.toLowerCase()"></div>
        <p class="status-text">Уровень: <strong>{{ currentLevel }}</strong></p>
        <p class="hint-text" v-if="currentHint">{{ currentHint }}</p>
      </div>
      <div class="data-row">
        <input
          type="password"
          :disabled="loader"
          :min-legnth="regRulesAndTerms.passwordMinLength"
          :max-length="regRulesAndTerms.passwordMaxLength"
          v-model="formData.confirmNewPassword"
          placeholder="Подвердите новый пароль"
          id="newPasswordInputConfirm">
        <span v-if="formData.confirmNewPassword && formData.confirmNewPassword.length > 0"
          @click="showHidePassword"
          title="Показать/скрыть пароль"
          id="toggle-new-password-confirm"
          toggle="#newPasswordInputConfirm"
          class="password-icon">👁</span>
      </div>
      <div class="data-row">
        <ErrorAlert v-if="errorMessage && errorMessage.length" :message="errorMessage" />
        <!-- <alert-label v-if="errorMessage && errorMessage.length"
          :closable=false
          color="red"
          textAlign="center"
          >{{errorMessage}}
        </alert-label> -->
        <div v-if="samePassword">
          <alert-label
            :closable=false
            textAlign="left"
            color="red"
            >новый пароль не отличается от старого
          </alert-label>
        </div>
        <button
          class="btn blue"
          :disabled="!isFormComplete || samePassword"
          @click="changePasswordClick">
          Изменить пароль
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AlertLabel from '../alert-label.vue';

export default {
  components: {
    AlertLabel
  },
  data: () => ({
    regRulesAndTermsLoader: true,
    regRulesAndTerms: null,
    loader: false,
    formData: {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    },
    // for password
    currentLevel: 'None',
    currentHint: '',
    isValidPassword: false,
    isSamePassword: false,

    errorMessage: '',
    confirmCodeDataLoader: true,
    confirmCodeRequired: false,
    confirmCodeData: {
      confirmCodeLength: 6,
      canEnterCode: true,
      expirationSeconds: 9999,
    },
  }),
  computed: {
    isFormComplete() {
      return !this.loader
        && this.isValidPassword
        && this.formData.oldPassword && this.formData.oldPassword.length
        && this.formData.newPassword && this.formData.newPassword.length
        && this.formData.oldPassword !== this.formData.newPassword
        && this.formData.newPassword === this.formData.confirmNewPassword;
    },
    passwordLevels() {
      return this.regRulesAndTerms.passwordLevels || [];
    },
    samePassword() {
      return this.formData.oldPassword
        && this.formData.oldPassword.length
        && this.formData.newPassword
        && this.formData.newPassword.length
        && this.formData.oldPassword === this.formData.newPassword;
    }
  },
  methods: {
    checkPasswordStrength() {
      if (!this.formData.newPassword || !this.formData.newPassword.length) {
        this.currentLevel = 'None';
        this.currentHint = '';
        return;
      }

      // Ищем первый уровень, которому соответствует пароль
      const matchedLevel = this.passwordLevels.find(level => {
        // Создаем регулярное выражение из строки, пришедшей с бэкенда
        const regex = new RegExp(level.regexPattern);
        return regex.test(this.formData.newPassword);
      });

      if (matchedLevel) {
        this.currentLevel = matchedLevel.name;
        this.currentHint = matchedLevel.description;
        this.isValidPassword = true;
      } else {
        this.currentLevel = 'Недостаточно надежный';
        // Выводим подсказку от минимального уровня (Low), так как пароль не прошел даже его
        const lowLevel = this.passwordLevels.find(l => l.name === 'Low');
        this.currentHint = lowLevel ? lowLevel.description : '';
      }
    },
    showHidePassword(e) {
      const el = $(`#${e.target.id}`);
      el.toggleClass('fa-eye fa-eye-slash');
      const input = $(el.attr('toggle'));
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
      } else {
        input.attr('type', 'password');
      }
    },
    changePasswordClick() {
      if (this.formData.newPassword === this.formData.oldPassword) {
        this.errorMessage = 'Новый пароль должен отличаться';
        return;
      }
      this.loader = true;
      this.errorMessage = '';
      const bodyData = {
        newPassword: this.formData.newPassword,
        oldPassword: this.formData.oldPassword
      };
      this.$http.post(`${this.$host.IdentityServiceApi}/ChangePassword`, bodyData)
      .then(
        (response) => {
          this.loader = false;
          const result = response.body;
          if (result.confirmCodeRequired) {
            this.showVerifyForm(result.data);
          } else if (result.token && result.token.accessToken) {
            this.$root.$emit('authenticated', result.token);
            this.$emit("success");
          }
        },
        (response) => {
          if (response.body && response.body.message)
            this.errorMessage = response.body.message;
          this.loader = false;
          if (this.confirmCodeRequired)
            this.$refs.verify.resetInput();
        },
      );
    },
    loadUserRegRulesAndTerms() {
      this.regRulesAndTermsLoader = true;
      this.$http.get(`${this.$host.IdentityServiceApi}/UserRegRulesAndTerms`)
      .then((response) => {
        this.regRulesAndTerms = response.body;
        this.regRulesAndTermsLoader = false;
      })
      .catch(() => {
        this.regRulesAndTerms = null;
        this.regRulesAndTermsLoader = false;
      })
    },
  },
  created() {
    this.loadUserRegRulesAndTerms();
  }
}
</script>

<style src='@/assets/css/password-strength-meter.css'>
</style>

<style scoped>
.password-icon {
  margin-left: -25px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
  cursor: pointer;
}
</style>